export default __webpack_public_path__ + "static/media/gear.bcc05e9b.gif";